"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftMessageTextField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _reactHookForm = require("react-hook-form");

var _utils = require("@alycecom/utils");

var _message = require("../../../CreateGift/store/gift/postcard/message");

var _gift = require("../../../CreateGift/store/gift/gift.selector");

var _customData = require("../../../CreateGift/store/customData/custom-data.selector");

var _invitationType = require("../../../CreateGift/store/gift/invitationType");

var _utils2 = require("../../../CreateGift/containers/GiftMessage/utils");

var minSalesIntegrationMessageRows = 4;

var GiftMessageTextField = function GiftMessageTextField(_ref) {
  var control = _ref.control,
      name = _ref.name,
      textFieldProps = (0, _objectWithoutProperties2.default)(_ref, ["control", "name"]);
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useController = (0, _reactHookForm.useController)({
    control,
    name
  }),
      error = _useController.fieldState.error,
      onChange = _useController.field.onChange;

  var text = (0, _reactRedux.useSelector)(_message.getMessageText);
  var shadowText = (0, _reactRedux.useSelector)(_message.getMessageShadowText);
  var sender = (0, _reactRedux.useSelector)(_gift.getGiftSender);
  var textCharsLimit = (0, _reactRedux.useSelector)(_invitationType.getMessageTextLimit);
  var tags = (0, _reactRedux.useSelector)(_customData.getFilteredCustomDataList);
  var recipient = (0, _reactRedux.useSelector)(_gift.getGiftRecipient);
  var giftLink = (0, _reactRedux.useSelector)(_message.getPreviewUrl);
  var giftProduct = (0, _reactRedux.useSelector)(_gift.getGiftProduct);
  var isAllowEditTemplate = (0, _reactRedux.useSelector)(_gift.getIsAllowEditTemplate);
  var replaceMap = (0, _react.useMemo)(function () {
    return (0, _utils2.generateReplaceMap)(sender, recipient, giftLink, giftProduct);
  }, [recipient, sender, giftLink, giftProduct]); // initialize template with placeholders

  (0, _react.useEffect)(function () {
    if (!shadowText) {
      dispatch((0, _message.setShadowText)(text));
    }
  }, [dispatch, text, shadowText]); // apply placeholder replacements

  (0, _react.useEffect)(function () {
    dispatch((0, _message.setText)((0, _utils.mapReplace)(shadowText, replaceMap)));
  }, [dispatch, shadowText, replaceMap]);
  var onTextChange = (0, _react.useCallback)(function (changedText) {
    var updatedShadowText = (0, _utils2.updateShadowText)(sender, changedText, shadowText);
    dispatch((0, _message.setText)(changedText));
    dispatch((0, _message.setShadowText)(updatedShadowText));
    onChange(changedText);
  }, [dispatch, onChange, sender, shadowText]);
  var onTextTagInsert = (0, _react.useCallback)(function (textWithInsertedTag) {
    dispatch((0, _message.setShadowText)(textWithInsertedTag));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_ui.TemplateMessageEditor, (0, _extends2.default)({}, textFieldProps, {
    value: text,
    hide: false,
    label: "Gift landing page message",
    minRows: minSalesIntegrationMessageRows,
    shadowText: shadowText,
    onChange: onTextChange,
    onInsert: onTextTagInsert,
    disabled: !isAllowEditTemplate,
    error: error && error.message,
    tags: tags,
    charsLimit: textCharsLimit
  }));
};

exports.GiftMessageTextField = GiftMessageTextField;